// DevHub Catalog — the /catalog route.
//
// The catalog went CARD-ONLY (list/table toggles were cut); the table view is no
// longer reachable, so this component simply redirects to the card grid. It is
// retained ONLY to carry the `catalogIndex` routeRef binding — App.tsx calls
// attachComponentData(CatalogTablePage, 'core.mountPoint', catalogPlugin.routes.
// catalogIndex), which is load-bearing for Backstage route discovery. Do NOT
// inline this redirect away without moving that binding.
// The query string is carried across: /catalog holds the catalogIndex routeRef and is the
// path people link to, so a bare `to="/catalog-cards"` silently dropped the browse state
// (?q=, ?category=) out of every shared or bookmarked /catalog URL — which is exactly the
// state that lives in the URL so it CAN be shared.
import { Navigate, useLocation } from 'react-router-dom';

export const CatalogTablePage = () => {
  const { search, hash } = useLocation();
  return <Navigate to={`/catalog-cards${search}${hash}`} replace />;
};
